import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class BackupsTableHeadersService {
  public tableHeadersRefunds: string[] = [
    // fase 2 ok fm
    // "Tipo documento afiliado",
    // "Nombre afiliado",
    "Documento comprador",
    "Nombre comprador",
    "Título valor",
    "Fecha vencimiento",
    "Valor garantizado",
    "Valor reclamado",
    "Fecha reclamado",
    "Sucursal",
    "Producto",
    "Contrato",
    "Valor reintegro",
    "Fecha reintegro",
    "Valor deducible",
    "Fecha deducible",
  ];

  public tableHeadersSettlement: string[] = [
    // fase 2 ok fm
    "Contrato",
    "Título valor",
    "Código de consulta",
    "Documento afiliado",
    "Nombre afiliado",
    "Documento comprador",
    "Nombre comprador",
    "Sucursal",
  ];

  public tableHeadersIndividualValueTitle: string[] = [
    // fase 2 ok fm
    "Seleccionar",
    "Estado radicación",
    "Causal devolución",
    "Contrato",
    "Producto",
    "Recuperación",
    "Fecha radicación",
    "Número radicación",
    "Título valor",
    "Documento afiliado",
    "Nombre afiliado",
    "Documento comprador",
    "Nombre comprador",
    "Deducible",
    "Valor factura",
    "Abonos",
    "Ver Abonos",
    "Exoneraciones",
    "Abono",
    "Valor reclamado",
    "Valor reintegro",

    "Sucursal",
    "Días aviso",
    "Reintegro recuperado",
    "Deducible recuperado",

    "Producto",
    "Fecha vencimiento",
    "Fecha máxima reclamación",
    "Fecha pago",
    "Días para reclamar",
    "Días de reintegro",
  ];

  public tableHeadersBackupsReport: string[] = [
    // fase 2 ok fm
    "Nombre afiliado",
    "Documento afiliado",
    "Título valor",
    "Nombre comprador",
    "Documento comprador",
    "Valor factura",
    "Abonos",
    "Valor reclamado",
    "Producto",
    "Fecha vencimiento",
    "Número radicación",
    "Estado radicación",
    "Fecha máxima reclamación",
    "Fecha pago",
  ];

  public tableHeadersPaymentsTable: string[] = [
    // "Seleccionar",
    "Estado radicación",
    "Causal devolución",
    "Contrato",
    "Deducible", //
    "Fecha radicación",
    "Número radicación",
    "Título valor",
    "Documento afiliado",
    "Nombre afiliado",
    "Documento comprador",
    "Nombre comprador",
    "Valor factura",
    "Abonos",
    // "Ver Abonos",
    "Exoneraciones",
    // "Abono",
    "Valor reclamado",
    "Producto",
    "Fecha vencimiento",
    "Fecha máxima reclamación",
    "Fecha pago",
    "Sucursal",
    "Días para reclamar",
    "Días de reintegro",
  ];

  public tableHeadersBackupsTable: string[] = [
    "Tipo Documento",
    "Documento",
    "Razón social",
    "Ver afiliado",
  ];

  public tableHeadersNonPaymentsTable: string[] = [
    "Seleccionar",
    "Estado",
    "Acciones",
    "Fecha", //
    "Contrato", //
    "Código consulta", //
    "Fecha vencimiento", //
    "Documento comprador", //
    "Documento afiliado", //
    "Sucursal", //
    "Autorización", //
    "Valor", //
    "Valor garantizado", //
    "Usuario", //
    "Pago", //
    "Número cheques", //
    "Módulo", //
    "Número siniestro", //
    "Número compra", //
    "Banco", //
    "Cuenta", //
    "Título valor", //
    "Fecha reporte", //
  ];

  public tableHeadersTransactions: string[] = [
    // "Seleccionar",
    "Título valor",
    "Contrato",
    "Valor",
    "Autorización",
    "Fecha emisión",
    "Fecha vencimiento",
    "Documento comprador",
    "Documento afiliado",
    "Sucursal",
    "CV",
    "Fecha exoneración parcial",
    "Usuario exoneración parcial",
    "Fecha exoneración total",
    "Usuario exoneración total",
    "Usuario carga factura",
    "Fecha de aviso no pago",
    "Fecha de descargo aviso",
    "Usuario descarga aviso",
    "Valor recuperado",
    "Estado recuperación",
  ];

  public tableHeadersDeductibles: string[] = [
    "Número de presentación",
    "Radicación",
    "Fecha de pago",
    "fecha límite para el deducible",
    "Día límite deducible",
    "Días",
    "Revolución deducible",
    "Recuperación del deducible",
    "Descontar",
    "Pagar al afiliado",
    "Inicio de sesión del sistema",
    "caja de recibos",
    "Tipo de recuperación",
    "Usuario actualizado",
    "Producto",
    "Subproducto",
    "Rama",
    "Establecimiento",
    "Contrato",
    "Documento de afiliado",
    "Tipo de documento del pagador",
    "Documento del pagador",
    "Nombre del pagador",
    "Número de facturación",
    "Sistema de fechas",
  ];

  constructor() {}
}
